/** es/ca/it are deliberately the words `www/contact.meta.ts` already serves — see slug-rewrites. */
export const routeName = 'contact';
export const slugs: Record<string, string> = {
	es: 'contacto',
	en: 'contact',
	ca: 'contacte',
	fr: 'contact',
	it: 'contatto',
};
export const sitemap = { changefreq: 'monthly', priority: '0.7', lastmod: '2026-08-21' };
